import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const takeInquiry = async (inquiryId: string): Promise<AxiosResponse> =>
  AxiosInstance.post('livechat/inquiries.take', {
    inquiryId,
  });
